import { Grid, Typography } from "@mui/material";
import { ContentStyle, DataGridListStyle } from "../../../Theme";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { v4 as uuid } from "uuid";
import NoRecords from "../../../components/NoRecords";
import ErrorOverlay from "../../../components/ErrorOverlay";
import { TextNTooltip } from "../../../components/Content";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmPopup from "../../../components/ConfirmPopup";
import { DialogPopup } from "../../../components/DialogPopup";
import YSSnackBar from "../../../uikit/YSSnackBar";
import { YSButton } from "../../../uikit/YSButton";
import { useEffect, useState } from "react";
import useFetch from "../../../CustomHooks/useFetch";
import {
  confirmTemplateMed,
  templateMedicationsList,
} from "../../../Apis/TemplateApis";
import { CircularProgress } from "@mui/material";

export default function PrescriptionTemplateDetails(props: any) {
  const pathParams = useParams();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deleteFavDrugsPopup, setDeleteFavDrugsPopup] = useState(false);
  const deleteRowData = async () => {};
  const navigate = useNavigate();
  const handleShowDeletePopupClick = () => {
    setDeleteFavDrugsPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeleteFavDrugsPopup(false);
  };
  const [selectionData, setSelectionData] = useState("");
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  // const [page, setPage] = useState(0);
  // const [pageSize, setPageSize] = useState(10);
  const columns: GridColDef[] = [
    {
      field: "drugDescription",
      headerName: "Drug Description",
      cellClassName: "w20",
      headerClassName: "w20",
      width: 170,
      renderCell: ({ row }) => (
        <TextNTooltip Text={row.drugDescription} color={"primary"} />
      ),
    },
    {
      field: "sig",
      headerName: "SIG",
      cellClassName: "w50",
      headerClassName: "w50",
      width: 150,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      cellClassName: "w10",
      headerClassName: "w10",
      width: 80,
    },
    {
      field: "refills",
      headerName: "Refills",
      cellClassName: "w10",
      headerClassName: "w10",
      width: 65,
    },
    // {
    //   field: "rxOtc",
    //   headerName: "Rx/OTC",
    //   cellClassName: "w20",
    //   headerClassName: "w20",
    //   width: 70,
    // },
  ];

  const Params = {
    templateId: pathParams?.templateId,
  };
  const { data, loading, error }: any = useFetch(
    Params,
    templateMedicationsList,
    []
  );

  const confirmTemplateMedications = async () => {
    try {
      setConfirmLoading(true);
      const body = {
        templatePrescriptionDTOsId: selectionData,
        patientId: sessionStorage.getItem("patientId"),
        userDetails: {
          doctorId: localStorage.getItem("doctorId"),
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await confirmTemplateMed(body);
      if (result?.data?.digitalRxStatusCode === 200) {
        navigate("/newrxpad/summary", {
          state: "confirmPrescTemplate",
        });
        sessionStorage.setItem(
          "locationData",
          JSON.stringify(result?.data?.response[0])
        );
        sessionStorage.setItem(
          "rxTabs",
          JSON.stringify(result?.data?.response[0]?.prescriptionFormList)
        );
        setConfirmLoading(false);
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        setConfirmLoading(false);
      }
    } catch (error) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Some thing went wrong!",
          variant: "error",
          open: true,
        };
      });
      setConfirmLoading(false);
    }
  };

  useEffect(() => {
    const filterOBSDrugs = data[0]?.templateDrugDTOList?.filter(
      (row: any) => !row?.obsoleteDrug
    );
    const Ids = filterOBSDrugs?.map(({ id }: any) => id);
    setSelectionData(Ids);
  }, [data]);

  // const [rowCountState, setRowCountState] = useState(
  //   data[0]?.pagination?.totalItems || 0
  // );

  // useEffect(() => {
  //   setRowCountState((prevRowCountState: any) =>
  //     data[0]?.pagination?.totalItems !== undefined
  //       ? data[0]?.pagination?.totalItems
  //       : prevRowCountState
  //   );
  // }, [data[0]?.pagination?.totalItems, setRowCountState]);
  return (
    <>
      <ContentStyle>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12}>
            <Typography
              className="help"
              component="h6"
              color="primary"
              variant="h6"
            >
              {data[0]?.templateName ?? ""}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                rows={data[0]?.templateDrugDTOList ?? []}
                headerHeight={36}
                sortingOrder={["desc", "asc"]}
                columns={columns}
                autoHeight
                rowHeight={40}
                disableSelectionOnClick
                checkboxSelection
                getRowId={(row) => row.id ?? uuid()}
                loading={loading}
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={error || undefined}
                selectionModel={selectionData}
                onSelectionModelChange={(ids: any) => {
                  setSelectionData(ids);
                }}
                hideFooter
                getRowClassName={(params) => {
                  if (params.row.obsoleteDrug) {
                    return "OP";
                  }
                  return "";
                }}
                // rowsPerPageOptions={[10]}
                // rowCount={rowCountState}
                // paginationMode="server"
                // page={page}
                // pageSize={pageSize}
                // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                // onPageChange={(newPage) => {
                //   setPage(newPage);
                // }}
              />
            </DataGridListStyle>
          </Grid>

          <Grid item xs={12} textAlign="center" className="btns">
            <YSButton
              onClick={() => {
                // props.setShowFlow(false);
                navigate("/prescription-template");
              }}
              className=""
              children={"Back"}
              size={"large"}
              type="button"
              color="primary"
              variant="outlined"
            />{" "}
            <YSButton
              onClick={() => {
                navigate("/newrxpad");
              }}
              className=""
              children={"Back to NewRx"}
              size={"large"}
              type="button"
              color="primary"
              variant="outlined"
            />{" "}
            <YSButton
              onClick={() => {
                confirmTemplateMedications();
              }}
              className=""
              children={
                confirmLoading ? (
                  <CircularProgress size={28} color="inherit" />
                ) : (
                  "Confirm"
                )
              }
              size={"large"}
              type="button"
              color="primary"
              variant="contained"
            />{" "}
          </Grid>
        </Grid>
      </ContentStyle>
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
      <DialogPopup
        windowsize={"sm"}
        show={deleteFavDrugsPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
    </>
  );
}
